import { render } from "./expireEdit.vue?vue&type=template&id=2cd078ac&ts=true"
import script from "./expireEdit.vue?vue&type=script&lang=ts"
export * from "./expireEdit.vue?vue&type=script&lang=ts"

import "./expireEdit.vue?vue&type=style&index=0&id=2cd078ac&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__